import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "zc3d_session_id";
const NAME_KEY = "zc3d_player_name";

export function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = "s-" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function getPlayerName() {
  return (localStorage.getItem(NAME_KEY) || "").slice(0, 18);
}

export function setPlayerName(name) {
  const clean = (name || "").trim().slice(0, 18);
  if (clean) localStorage.setItem(NAME_KEY, clean);
}

// Fetch a few random ghost paths from the same level. Safe to call without
// awaiting — returns [] on failure. The caller renders these UFOs replaying
// their paths during the run, looped so they stay visible the whole time.
export async function fetchGhosts(levelId, count = 3) {
  try {
    const res = await axios.get(`${API_BASE}/ghosts/sample`, {
      params: { level_id: levelId, count, exclude: getSessionId() },
      timeout: 4000,
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

// Send the current run's recorded path. `path` is an array of
// {t, x, z} samples (~4 Hz). Fire-and-forget — never throws.
export async function postGhost({ levelId, wave, duration, path }) {
  if (!path || path.length < 4) return;
  try {
    await axios.post(
      `${API_BASE}/ghosts/record`,
      {
        session_id: getSessionId(),
        name: getPlayerName() || "Player",
        level_id: levelId,
        wave: wave || 1,
        duration,
        path,
      },
      { timeout: 4000 }
    );
  } catch {
    // ignore
  }
}
